module.exports = __webpack_public_path__ + "static/Przesiewacz-c9e6fefed8b541deaec5bb4f20cd3fd7.png";